<template>
  <div>
    <Jumbotron title="" />

    <b-container style="margin-top: -5em;">
      <b-row class="mt-3">
        <b-col cols="8">
          <div class="sg-rounded-container p-4 mx-3">
            <PriceDetail :payment="payment" :price_detail="price_detail" :total_detail="total_detail" />
          </div>

          <div class="sg-rounded-container p-4 m-3">
            <b-row>
              <b-col class="center-base all">
                <span style="font-size: 22px;">Upload Proof of Payment</span>
              </b-col>
              <b-col>
                <b-form-file
                  placeholder="Choose a file..."
                  drop-placeholder="Drop file here..."
                  name="payment_file"
                  @change="appendFormData"
                />
              </b-col>
            </b-row>
          </div>

          <div class="px-4 mx-3">
            <b-row class="justify-content-center mt-3">
              <b-col cols="6">
                <b-button block variant="success" size="lg" class="sg-box-shadow" @click="confirmPayment" :disabled="confirm_button_state">
                  Confirm Payment
                </b-button>
              </b-col>
            </b-row>
          </div>
        </b-col>

        <b-col cols="4">
          <div v-if="tgbs_order_id" class="sg-rounded-container p-4 mx-3">
            <OrderSummary :key="keyComponent" :tgbs_order_id="tgbs_order_id" />
          </div>

          <div v-else class="sg-rounded-container center-base all" style="min-height: 200px;">
            <b-spinner variant="primary" type="grow" label="Spinning" />
          </div>
        </b-col>
      </b-row>

      <b-row class="mt-5" />
    </b-container>
  </div>
</template>

<script>
// external dependencies
import swal from 'sweetalert'
import VueJwtDecode from 'vue-jwt-decode'

// custom component
import Jumbotron from '@/components/Jumbotron'
import OrderSummary from '@/components/Pay/OrderSummary'
import PriceDetail from '@/components/Pay/PriceDetail'

// api call
import PaymentAPI from '@/api/PaymentAPI'

export default {
  name: 'Pay_Confirmation',
  components: {
    Jumbotron,
    OrderSummary,
    PriceDetail
  },
  data () {
    return {
      tgbs_order_id: '',

      payment: {},
      price_detail: [],
      total_detail: {},

      sg_payment_id: '',
      payment_id: '',
      confirm_data: new FormData(), // untuk upload file

      keyComponent: 0,
      confirm_button_state: false,
      errors: []
    }
  },
  beforeCreate: function () {
    if (this.$session.get('jwt') && this.$session.exists()) {
      let decode = VueJwtDecode.decode(this.$session.get('jwt'))
      this.user = decode
    } else {
      this.user = null
    }
  },
  created: function () {
    if (this.isEmpty(this.$route.params)) this.$router.push({ name: 'MyAccount' })
    else {
      if (this.isEmpty(this.user)) this.$router.push({ name: 'Login' })
      else {
        this.paymentFetchPaymentList(this.$route.params.payment_id)
      }
    }
  },
  methods: {
    // PREREQUISITES
    forceRerender: function () {
      // value nya gak auto ke update stlh di ambil dr DB
      this.keyComponent += 1
    },
    isEmpty: function (obj) {
      for (var key in obj) {
        if (obj.hasOwnProperty(key)) return false
      }
      return true
    },
    toMoney: function (int) {
      if (int) return int.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1.')
    },
    appendFormData: function (e) {
      let fileList = e.target.files

      var files = e.target.files || e.dataTransfer.files
      if (!files.length) return

      if (!fileList.length) return

      // append the files to FormData
      Array
        .from(Array(fileList.length).keys())
        .map(x => {
          if (this.confirm_data.get(e.target.name)) {
            this.confirm_data.set(e.target.name, fileList[x], fileList[x].name)
          } else {
            this.confirm_data.append(e.target.name, fileList[x], fileList[x].name)
          }
        })
    },
    // END PREREQUISITES

    // HTTP REQUEST
    paymentFetchPaymentList: async function (_id) {
      try {
        const x = await PaymentAPI.fetchPaymentList({
          select: 'payment_id euridrrate price currency tgbs_order_id',
          query: {
            is_delete: false,
            _id: _id
          }
        })

        let fetched = x.data.payments[0]

        // data yg diperlukan
        this.sg_payment_id = fetched._id
        this.payment_id = fetched.payment_id

        // data yg diperlukan untuk child component (masih menyesuaikan dg Pay_Now)
        this.tgbs_order_id = fetched.tgbs_order_id
        this.payment = {
          euridrrate: fetched.euridrrate
        }
        this.price_detail.push({ label: 'Sub Total', currency: 'IDR', amountIDR: this.toMoney(fetched.price), amountEUR: null })
        this.price_detail.push({ label: 'Additional', currency: 'IDR', amountIDR: this.toMoney(0), amountEUR: null })
        this.total_detail = {
          label: 'Total',
          currency: 'IDR',
          amountIDR: this.toMoney(fetched.price),
          amountEUR: null
        }

        this.forceRerender()
      } catch (error) {
        swal({
          title: 'Whoops!',
          text: 'We encounter some error in our system, please try again later',
          icon: 'danger',
          button: {
            text: 'Ok'
          }
        })
      }
    },
    confirmPayment: async function () {
      let flag = 0
      this.confirm_button_state = true

      if (!this.confirm_data.get('payment_file')) flag++

      if (flag > 0) {
        swal({
          title: 'Whoops!',
          text: 'You need to choose a files to upload.',
          icon: 'error',
          button: {
            text: 'Ok'
          }
        })

        this.confirm_button_state = false
      } else {
        this.confirm_data.append('sg_payment_id', this.sg_payment_id)
        this.confirm_data.append('tgbs_order_id', this.tgbs_order_id)
        this.confirm_data.append('payment_id', this.payment_id)

        try {
          await PaymentAPI.confirmPaymentOrderBankTrf(this.confirm_data)

          this.$router.push({ name: 'Pay_Success' })
        } catch (error) {
          swal({
            title: 'Whoops!',
            text: 'We fail to confirm your payment.',
            icon: 'error',
            button: {
              text: 'Ok'
            }
          })

          this.confirm_button_state = false
        }
      }
    }
    // END HTTP REQUEST
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Pay/Confirmation.vue